import { render, staticRenderFns } from "./CruiseSpeedFields.vue?vue&type=template&id=2d49b31a&"
import script from "./CruiseSpeedFields.vue?vue&type=script&lang=ts&"
export * from "./CruiseSpeedFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CruiseSpeedFields.vue"
export default component.exports